import { combineReducers } from 'redux'

import appStates from './AppStates/AppStates'
import getAppBanner from './AppBannerReducer'
import getAppScroll from './AppScrollReducer'
import getDataReady from './DataReadyReducer'
import getSchools from './SchoolsReducer'
import getStudents from './StudentsReducer/StudentsReducer'
import getTheme from './ThemeReducer'
import getUser from './UserReducer'
import getChangelog from './ChangelogReducer'
import getEvaluationQuestions from './EvaluationQuestionsReducer'
import getFreeFields from './FreeFieldsReducer'
import getBadgesProperties from './BadgesReducer'
import schoolSections from './SchoolSectionsReducer/SchoolSectionsReducer'
import actTypeCategories from './ActTypeCategoriesReducer'
import institutionConstraints from './InstitutionConstraintsReducer/InstitutionConstraintsReducer'
import institutionTemplates from './InstitutionTemplatesReducer/InstitutionTemplatesReducer'
import satisfactionRatioFilter from './SatisfactionRatioFilterReducer'
import shifts from './ShiftsReducer/ShiftsReducer'
import presets from './ShiftsPresetsReducer/ShiftsPresetsReducer'
import tags from './TagsReducer'
import pauseQuotas from './PauseQuotasReducer/PauseQuotasReducer'
import profileDatas from './ProfilPageReducer'
import quotas from './QuotasReducer/QuotasReducer'
import internships from './InternshipsReducer/InternshipsReducer'
import { localeReducer as locale } from 'react-localize-redux'
import shiftsManager from './ShiftsManagerReducer/ShiftsManagerReducer'
import studentsExtraInformations from './StudentsExtraInfos'
import internshipsManager from './InternshipsManagerReducer/InternshipsManagerReducer'
import schoolAssistants from './SchoolAssistantsReducer'

export default combineReducers({
  actTypeCategories: actTypeCategories,
  appStates: appStates,
  getAppBanner: getAppBanner,
  getAppScroll: getAppScroll,
  getDataReady: getDataReady,
  getSchools: getSchools,
  getStudents: getStudents,
  getTheme: getTheme,
  getUser: getUser,
  getChangelog: getChangelog,
  getEvaluationQuestions: getEvaluationQuestions,
  getFreeFields: getFreeFields,
  getBadgesProperties: getBadgesProperties,
  institutionConstraints: institutionConstraints,
  institutionTemplates: institutionTemplates,
  internships: internships,
  internshipsManager: internshipsManager,
  profileDatas: profileDatas,
  quotas: quotas,
  satisfactionRatioFilters: satisfactionRatioFilter,
  shifts: shifts,
  pauseQuotas: pauseQuotas,
  presets: presets,
  shiftsManager: shiftsManager,
  studentsExtraInformations: studentsExtraInformations,
  tags: tags,
  schoolSections: schoolSections,
  locale: locale,
  schoolAssistants
})
